<template>
  <div>
    <table-temp
      title
      :flag="1"
      :tableData="tableData"
      :columnData="tableConf"
      @editTable="editTable"
      @handleSelectionChange="handleSelectionChange"
    >
      <div slot="tool">
        <el-button class="borderBtn" @click="addDialog">添加</el-button>
        <el-button class="borderBtn" @click="delCompanyIn">删除</el-button>
      </div>
    </table-temp>
    <step-dialog
      :dialogVisible="dialogVisible"
      :title="title"
      @closeDialog="closeDialog"
      @reload="reloadData"
      :data="commonData"
      :codeId="codeId"
      :key="key"
    ></step-dialog>
    <div class="footerBtn">
      <el-button @click="pre">上一步</el-button>
      <el-button class="mainBtn" @click="save">保存</el-button>
      <el-button class="mainBtn" @click="next">保存并下一步</el-button>
    </div>
  </div>
</template>

<script>
import TableTemp from "@table/table";
import { step4 } from "@/conf/Report-manager";
import StepDialog from "../dialog/step4Dialog";
import comMixin from "common/js/mixin/comMixin";

import { getReportLargeChangeByReportCode, delCompany } from "common/js/api";

export default {
  components: {
    TableTemp,
    StepDialog,
  },

  mixins: [comMixin],

  data() {
    return {
      title: "添加企业重大变更事项",
      tableData: [],
      tableConf: step4,
      dialogVisible: false,
      key: 0,
      selectIds: "",
      step: 3,
      codeId: this.$route.query.codeId,
      commonData: {},
    };
  },

  mounted() {
    this.getCompanyData();
  },

  methods: {
    async getCompanyData() {
      const res = await getReportLargeChangeByReportCode(this.codeId);
      this.tableData = res.result;
      this.tableData.forEach((item) => {
        item.changeTime = this.$moment(item.changeTime).format("YYYY-MM-DD");
      });
    },

    reloadData() {
      this.getCompanyData();
    },

    handleSelectionChange(ids) {
      this.selectIds = ids;
    },

    async delCompanyIn() {
      if (!this.selectIds) {
        this.$message({
          message: "请先选择删除的列表,再点击删除!",
          type: "warning",
        });
        return;
      }
      await delCompany(this.selectIds);
      this.$message({
        message: "删除成功!",
        type: "success",
      });
      this.reloadData();
    },

    editTable(val) {
      this.title = "编辑企业重大变更事项";
      this.commonData = val.scope.row;
      this.$set(this.commonData, "dte", new Date());
      this.key++;
      this.dialogVisible = true;
    },

    async save() {
      return true;
    },

    addDialog(val) {
      this.title = "添加企业重大变更事项";
      this.commonData = {};
      this.$set(this.commonData, "dte", new Date());
      let changeTime = this.$moment(new Date()).format("YYYY-MM-DD");
      this.$set(this.commonData, "changeTime", changeTime);
      this.key++;
      this.dialogVisible = true;
    },

    closeDialog() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style></style>
